import {Rental} from '../../../../common/types/rental'
import {formatDate, parseISO} from '../../../../common/utils/dateUtils'

export interface RentalFailuresTimeOfDayData {
  label: string
  count: number
  percentage: number
}

export const generateRentalFailuresTimeOfDayData = (rentals: Rental[]): RentalFailuresTimeOfDayData[] => {
  const rentalsByDate: Record<string, Rental[]> = {}
  const uniqueFailedByDate: Record<string, Set<string>> = {}

  rentals.forEach((rental) => {
    const rentStart = rental.rentStart
    if (rentStart) {
      const dateStr = formatDate(parseISO(rentStart))

      if (!rentalsByDate[dateStr]) {
        rentalsByDate[dateStr] = []
      }
      rentalsByDate[dateStr].push(rental)

      if (rental.numberOfFailedOpenings > 0 && rental.numberOfSuccessfulOpenings === 0) {
        if (!uniqueFailedByDate[dateStr]) {
          uniqueFailedByDate[dateStr] = new Set<string>()
        }
        const uniqueKey = `${rental.rentBy?.id}_${rental.compartment?.id}`
        uniqueFailedByDate[dateStr].add(uniqueKey)
      }
    }
  })

  return Object.keys(rentalsByDate)
    .sort()
    .map((date) => {
      const totalRentals = rentalsByDate[date]?.length ?? 0
      const uniqueFailedSet = uniqueFailedByDate[date]
      const count = uniqueFailedSet ? uniqueFailedSet.size : 0

      return {
        label: date,
        count,
        percentage: totalRentals > 0 ? count / totalRentals : 0,
      }
    })
}
